// hooks/useIsMobile.js
//
// Той самий брейкпоінт (768px), що вже використовувався в index.jsx для
// перемикання верстки табів — винесено сюди, щоб таблиці з вкладеною
// деталізацією (район → садочки → заявки) теж могли перемикати спосіб
// показу деталізації на мобільному.
import { useState, useEffect } from 'react';

export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= breakpoint);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);

  return isMobile;
};
